export const FETCH_VENDOR_COMPANY = 'FETCH_VENDOR_COMPANY';
export const FETCH_ONE_VENDOR_COMPANY = 'FETCH_ONE_VENDOR_COMPANY';
export const FILTER_VENDOR_COMPANY = 'FILTER_VENDOR_COMPANY';
